import { json } from "@sveltejs/kit";
const GET = async () => {
  return json({
    status: "ok",
    websocket: {
      url: "ws://localhost:8009",
      protocol: "json",
      messageTypes: ["CONNECTED", "OUTPUT", "ERROR", "STATE_UPDATE", "SEND_INPUT"]
    }
  });
};
export {
  GET
};
